var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6227 6.56533C17.8937 6.56463 17.1948 6.27474 16.6794 5.75929C16.1639 5.24385 15.874 4.54495 15.8733 3.816V0H3.588C2.6364 0 1.72378 0.378023 1.0509 1.0509C0.378023 1.72378 0 2.6364 0 3.588V25.2173C0.00141312 26.168 0.380056 27.0793 1.05278 27.751C1.72551 28.4227 2.63732 28.8 3.588 28.8H18.336C19.2869 28.8 20.1989 28.4225 20.8717 27.7505C21.5444 27.0785 21.9229 26.1669 21.924 25.216V6.56533H18.6227Z",
    fill: "#F1EAF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9237 6.56533H18.6224C17.8934 6.56462 17.1945 6.27474 16.6791 5.75929C16.1636 5.24385 15.8738 4.54495 15.873 3.816V0L21.9237 6.56533Z",
    fill: "#6516B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5252 22.7467H7.85325C6.67062 22.7467 5.71191 23.7054 5.71191 24.888V29.8587C5.71191 31.0413 6.67062 32 7.85325 32H24.5252C25.7079 32 26.6666 31.0413 26.6666 29.8587V24.888C26.6666 23.7054 25.7079 22.7467 24.5252 22.7467Z",
    fill: "#6516B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5411 28.4493V29.4186H9.53711V28.4493H10.5411Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0166 28.0133V29.4187H11.0459V25.4093H12.6166C13.0939 25.4093 13.457 25.5276 13.7059 25.764C13.8322 25.8879 13.9309 26.0372 13.9955 26.2019C14.0601 26.3667 14.0891 26.5432 14.0806 26.72C14.0848 26.9532 14.0268 27.1833 13.9126 27.3867C13.7968 27.5857 13.624 27.7454 13.4166 27.8453C13.1671 27.9643 12.8928 28.0219 12.6166 28.0133H12.0166ZM13.0939 26.72C13.0939 26.3644 12.8992 26.1867 12.5099 26.1867H12.0166V27.2307H12.5099C12.8992 27.2342 13.0939 27.064 13.0939 26.72Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1174 29.4187H17.148L15.524 26.9573V29.4187H14.5547V25.4093H15.524L17.1467 27.8933V25.4093H18.116L18.1174 29.4187Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9056 25.7333C22.2292 25.9754 22.4466 26.3333 22.5123 26.732H21.4856C21.4183 26.5892 21.3102 26.4695 21.175 26.388C21.0222 26.2974 20.8472 26.2512 20.6697 26.2547C20.5317 26.249 20.3942 26.2736 20.2668 26.3268C20.1394 26.38 20.0252 26.4605 19.9323 26.5627C19.7375 26.7968 19.6384 27.0959 19.655 27.4C19.655 27.7813 19.7523 28.0742 19.947 28.2787C20.0564 28.3849 20.1868 28.467 20.3299 28.5199C20.4729 28.5727 20.6255 28.595 20.7776 28.5853C20.9952 28.5891 21.2081 28.5222 21.3843 28.3947C21.5639 28.2603 21.6934 28.0697 21.7523 27.8533H20.5283V27.156H22.5643V28.1333C22.4855 28.3718 22.3619 28.5931 22.2003 28.7853C22.0258 28.9923 21.8083 29.1588 21.563 29.2733C21.2848 29.4017 20.9813 29.4656 20.675 29.46C20.3028 29.4694 19.9348 29.3802 19.6083 29.2013C19.3095 29.0338 19.0662 28.7826 18.9083 28.4787C18.7393 28.1513 18.6545 27.787 18.6617 27.4187C18.6536 27.0481 18.7384 26.6814 18.9083 26.352C19.066 26.0488 19.3082 25.7978 19.6056 25.6293C19.9274 25.4521 20.2904 25.3633 20.6576 25.372C21.1023 25.3502 21.5414 25.4774 21.9056 25.7333Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29329 8.896H5.45996V10.7293H7.29329V8.896Z",
    fill: "#6516B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12825 10.7293H7.29492V12.5626H9.12825V10.7293Z",
    fill: "#6516B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9613 8.896H9.12793V10.7293H10.9613V8.896Z",
    fill: "#6516B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7943 10.7293H10.9609V12.5626H12.7943V10.7293Z",
    fill: "#6516B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6312 8.896H12.7979V10.7293H14.6312V8.896Z",
    fill: "#6516B4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4642 10.7293H14.6309V12.5626H16.4642V10.7293Z",
    fill: "#6516B4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29329 12.56H5.45996V14.3933H7.29329V12.56Z",
    fill: "#6516B4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12825 14.3933H7.29492V16.2266H9.12825V14.3933Z",
    fill: "#6516B4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9613 12.56H9.12793V14.3933H10.9613V12.56Z",
    fill: "#6516B4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7943 14.3933H10.9609V16.2266H12.7943V14.3933Z",
    fill: "#6516B4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6312 12.56H12.7979V14.3933H14.6312V12.56Z",
    fill: "#6516B4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4642 14.3933H14.6309V16.2266H16.4642V14.3933Z",
    fill: "#6516B4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29329 16.2413H5.45996V18.0747H7.29329V16.2413Z",
    fill: "#6516B4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12825 18.0747H7.29492V19.908H9.12825V18.0747Z",
    fill: "#6516B4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9613 16.2413H9.12793V18.0747H10.9613V16.2413Z",
    fill: "#6516B4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7943 18.0747H10.9609V19.908H12.7943V18.0747Z",
    fill: "#6516B4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6312 16.2413H12.7979V18.0747H14.6312V16.2413Z",
    fill: "#6516B4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4642 18.0747H14.6309V19.908H16.4642V18.0747Z",
    fill: "#6516B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/PNG.f7bc857c2c98fb47163e7a30e230e450.svg";
export { ForwardRef as ReactComponent };